<template>
  <div>
    <router-view />
    <template v-if="active">
      <v-dialog
        v-model="alertdialog"
        transition="dialog-top-transition"
        max-width="290"
      >
        <template>
          <v-card>
            <v-card-title class="text-h5"> Warning </v-card-title>

            <v-card-text> System will auto Logout in 2 min </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="grey darken-1" text v-on:click="closeAlert(false)">
                cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import store from "./store/index";
export default {
  data() {
    return {
      events: ["click", "mousemove", "mousedown", "scroll", "load", "keypress"],
      warningTimer: null,
      logoutTimer: null,
      alertdialog: false,
      active: false,
    };
  },
  mounted() {
    this.setFavICON()
    this.events.forEach((event) => {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.setTimers();
  },
  destroyed() {
    this.events.forEach((event) => {
      window.removeEventListener(event, this.resetTimer);
    }, this);
    this.resetTimer();
  },
  methods: {
    setFavICON() {
      const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = "https://dimitra-public-images.s3.amazonaws.com/dimitra_favicon.ico";
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    setTimers() {
      this.warningTimer = setTimeout(this.warningMessage, 13 * 60 * 1000);
      this.logoutTimer = setTimeout(this.autoLogout, 15 * 60 * 1000);
    },
    async warningMessage() {
      const isAuth = await store.getters.isAuthenticated;
      console.log(isAuth);
      if (isAuth) {
        console.log("on");
        this.active = true;
        this.alertdialog = true;
        // alert("System will logg off in 1 min")
      } else {
        this.resetTimer();
      }
    },
    closeAlert() {
      this.alertdialog = false;
      this.active = false;
    },
    async autoLogout() {
      console.log("hi");
      await store.dispatch("logout");
      window.location.replace("/login");
      // this.$router.push({ name: "Login" });
    },
    resetTimer() {
      // console.log("off")
      clearTimeout(this.warningTimer),
        clearTimeout(this.logoutTimer),
        this.setTimers();
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: "Poppins", sans-serif;
}

@font-face {
  font-family: pop_light;
  src: url("/font/Poppins-Light.ttf");
}
@font-face {
  font-family: pop_regular;
  src: url("/font/Poppins-Regular.ttf");
}
@font-face {
  font-family: Poppins-Medium;
  src: url("/font/Poppins-Medium.ttf");
}
@font-face {
  font-family: pop_semiBold;
  src: url("/font/Poppins-SemiBold.ttf");
}
</style>
